import type { ReactNode } from 'react';

export const symbol_mobile_unlock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M380-320h160q17 0 28.5-11.5T580-360v-120q0-17-11.5-28.5T540-520h-20v-40q0-17 11.5-28.5T560-600q17 0 28.5 11.5T600-560v20q0 8 6 14t14 6q8 0 14-6t6-14v-20q0-33-23.5-56.5T560-640q-33 0-56.5 23.5T480-560v40H380q-17 0-28.5 11.5T340-480v120q0 17 11.5 28.5T380-320ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Z"
		/>
	</svg>
);
